import React, { useEffect, useState } from "react"
import styles from './styles.module.scss'
import { getAdminPendente } from '../../services/api-auto';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom'
import ArrowForward from '@material-ui/icons/ArrowForward'

const AlertaAdminPendente = ({}) => {

    const navigate = useHistory();
    const [open, setOpen] = useState(false)
    const [pendentes, setPendentes] = useState([])

    const loadPendentes = async () => {
        const storage = localStorage.getItem("adminPendente")
        if(storage !== undefined && storage !== null){
            setPendentes(JSON.parse(storage))
        }else{
            const info = await getAdminPendente()
            localStorage.setItem('adminPendente',JSON.stringify(info.data.data))
        }
    }

    useEffect(() => {
        loadPendentes();
    },[])

    return (
        <div className={styles.wrapper}>

            <button onClick={()=>setOpen(!open)} className={styles.icon}>
                <FontAwesomeIcon icon={faBell}/>
             { Boolean(pendentes.length) && (
                    <div className={styles.number}>
                        {pendentes.length}
                    </div>
                )}

                <div className={styles.menuAltWrapper}>
                    <div className={ open ? styles.menuAltButtons : styles.close} >
                        <a href="/administradores?listaPendente=true">
                            Visualizar novos cadastros
                            <ArrowForward htmlColor="#5CCBE1" className="menuArrow"/>
                        </a>
                    </div>
                </div>
            </button>
        </div>
    )
}

export default AlertaAdminPendente